const ajaxinateContainer = document.querySelector("#AjaxinatePagination");
let gridContainer = "#product-grid";
if (ajaxinateContainer) {
  ajaxinateContainer.dataset.container &&
    (gridContainer = ajaxinateContainer.dataset.container);
  document.addEventListener("DOMContentLoaded", function () {
    var endlessScroll = new Ajaxinate({
      container: gridContainer,
      // pagination: '.load-more-btn',
      method: "scroll",
      offset: 10,
      loadingText: "",
    });
  });
}
